// extracted by mini-css-extract-plugin
export default {"item":"Item_item__cZOV-","image":"Item_image__FLyGZ"};